import api from '@services/api';
import { CollaboratorOverheadResponse, OverheadAndProjectResponse, OverheadProjectResponse } from '../models/overhead';
import { ProviderRequest, ProviderSearchByBranchRequest } from '../models/providersResponse';

/**
 * <p>
 * API endpoints that cover all resource period related CRUD calls
 */
export const ProviderApi = api.injectEndpoints({
  endpoints: (builder) => ({
    listAllByPeriod: builder.query<OverheadProjectResponse[], string>({
      query: (period: string) => ({
        url: `/indirect/overhead-sharing-config/listAllByPeriod?period=${period}`,
        method: 'GET',
        providesTags: ['listAllByPeriod'],
      }),
    }),
    listById: builder.query<OverheadAndProjectResponse, number>({
      query: (id) => ({
        url: `/indirect/overhead-sharing-config/listById?id=${id}`,
        method: 'GET',
        providesTags: ['listAllByPeriod'],
      }),
    }),
    listAllOverheadByPeriodAndProvider: builder.query<CollaboratorOverheadResponse[], ProviderRequest>({
      query: (request: ProviderRequest) => ({
        url: `/indirect/overhead-sharing-config-detail/listAllByPeriodAndProvider?period=${request.date}&providerId=${request.id}`,
        method: 'GET',
        providesTags: ['listAllByPeriod'],
      }),
    }),
    listSearchByBranch: builder.query<OverheadProjectResponse[], ProviderSearchByBranchRequest>({
      query: (request: ProviderSearchByBranchRequest) => ({
        url: `/indirect/overhead-sharing-config/searchBy?period=${request.date}&branch=${request.branch}`,
        method: 'GET',
        providesTags: ['listAllByPeriod'],
      }),
    }),
  }),
});

export const {
  useListAllByPeriodQuery,
  useListByIdQuery,
  useListAllOverheadByPeriodAndProviderQuery,
  useListSearchByBranchQuery,
} = ProviderApi;
